import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "katex/dist/katex.min.css";
import "./index.css";
import API_BASE_URL from './config/api';

// Global fetch patch: prefix relative /api/* with API_BASE_URL
const originalFetch = window.fetch.bind(window);
window.fetch = (input, init) => {
  try {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.startsWith('/api/')) {
      const prefixed = `${API_BASE_URL}${url}`;
      return originalFetch(prefixed, init);
    }
  } catch (_) {}
  return originalFetch(input, init);
};

const root = createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);